import React from "react";
import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";


const RecursosHumanos = () => {
  const bucketUrl = process.env.REACT_APP_BUCKET;
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="container text-center">
          <div className="row">
            <div className="col">
              <div className="TituloPrincipal">
                <br /> <h1>Recursos Humanos</h1>
              </div>
              <center>
                <hr className="linea-horizontal"></hr>
              </center>
            </div>
            <div className="col">
              <div className="Text_Buttons_Radio_buttons">
              </div>
            </div>
          </div>
        </div>

        <div class="table-container">
          <table class="styled-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Nombre Del Proceso</th>
                <th>Descripción</th>
                <th>Documentación</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  <p>   
                    <b>Solicitud de Alta de Colaborador</b>
                  </p>
                </td>
                <td>
                  <p>
                    En cualquier organización, contar con un proceso 
                    formalizado de selección, evaluación y contratación de personal 
                    es fundamental para asegurar que los nuevos colaboradores no solo 
                    cubran los requisitos técnicos del puesto, sino que también se 
                    alineen con la cultura, valores y objetivos estratégicos de la empresa.
                  </p>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/formato-alta-colaborador-interno-netjer.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Formato Alta
                  </a>{" "}
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/pdf/carta-responsiva-alta.pdf`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Formato <br /> Carta Responsiva
                  </a>{" "}
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/recursos-humanos/alta-colaborador-procedimiento"
                  >
                    Procedimiento
                  </Button>
                </td>
              </tr>

              <tr>
                <td>2</td>
                <td>
                  <p>
                    <b>Solicitud de Baja de Colaborador </b>
                  </p>
                </td>

                <td>
                  <p>
                    Descripción:
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/administracion-de-incidentes/diagrama-autoservicio-email"
                    disabled
                  >
                    Descargar Formato
                  </Button>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/administracion-de-incidentes/narrativa-autoservicio-email"
                    disabled
                  >
                    Procedimiento
                  </Button>
                </td>
              </tr>  

              <tr>  
                <td>3</td>
                <td>
                  <p>   
                    <b>Solicitud de Uso de la Camioneta</b>
                  </p>
                </td>  
                <td>
                  <p>
                  La camioneta utilitaria representa una herramienta esencial 
                  para las operaciones diarias, transporte de personal y traslado 
                  de materiales. Establecer un control riguroso de su 
                  uso—incluyendo calendario de reservas, bitácora de kilometraje, y 
                  políticas de mantenimientos—permite optimizar costos, prolongar su 
                  vida útil y garantizar la seguridad de los colaboradores.
                  </p>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/formato-asignacion-camioneta.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Formato Asignación Camioneta
                  </a>{" "}
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/recursos-humanos/solicitud-camioneta"
                  >
                    Procedimiento
                  </Button>
                </td>
              </tr>

              <tr>  
                <td>4</td>
                <td>
                  <p>   
                    <b>Incidencias</b>
                  </p>
                </td>  
                <td>
                  <p>
                    Guía de ingreso de incidencia para nómina
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/recursos-humanos/incidencias-rh"
                  >
                    Procedimiento
                  </Button>
                </td>
              </tr>

              
            </tbody>
          </table>
        </div>
      </Container>
    </>
  );
};

export default RecursosHumanos;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
